var map = {
	"./auto.svg": "a37a",
	"./bici.svg": "4c61",
	"./bus.svg": "eb2a",
	"./mono-cicle.svg": "299c",
	"./moto.svg": "60b7",
	"./train.svg": "d097",
	"./ufo.svg": "c232",
	"./walk.svg": "bf54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3bb";